import * as React from 'react';
import { render } from 'react-dom';
import './index.css';
import App from './App';
import { AppStore } from './stores';
import { Provider } from 'mobx-react';
import { FluentProvider, webDarkTheme } from '@fluentui/react-components';


declare global {
  interface Window { webkit: any; app: any; android: WebAppInterface; platform: string }
  interface WebAppInterface { postMessage(message: string): any; }
}

render(
  <Provider appStore={new AppStore()}>
    <FluentProvider theme={webDarkTheme}>
      <App
        ref={(app: any) => {
          if (app) {
            window.app = app
          }
        }}
      />
    </FluentProvider>
  </Provider>,
  document.getElementById('root')
);